/**
 * Shared DD Module
 *
 * Collaborative due diligence between investors (Premium feature).
 */

// Types
export type {
  SharedDueDiligence,
  DDCollaborator,
  DDNote,
  DDConclusion,
  DDInvite,
  DDDocumentRef,
  CollaboratorRole,
  CollaboratorStatus,
  NoteCategory,
  ConclusionDecision,
  NoteReaction,
} from './types';

// Constants
export {
  DD_INVITE_EXPIRY_DAYS,
  MAX_COLLABORATORS,
  NOTE_CATEGORIES,
  CONCLUSION_CONFIG,
  ROLE_CONFIG,
} from './types';

// Helpers
export {
  generateDDInviteToken,
  isDDInviteExpired,
  canAddNotes,
  canSetConclusion,
  formatRelativeTime,
  getSyndicateSummary,
} from './types';

// DB-backed data layer (collaborative DD is server state — see use-shared-dd.ts)
export {
  sharedDDKeys,
  useMySharedDDs,
  useInvitedSharedDDs,
  useSharedDD,
  useSharedDDsForMyStartup,
  useSharedDDRealtime,
  useCreateSharedDD,
  useCloseSharedDD,
  useToggleSyndicateMode,
  useAddNote,
  useUpdateNote,
  useDeleteNote,
  useReactToNote,
  useSetConclusion,
  useRemoveCollaborator,
  useInviteCollaborator,
  useAcceptInvite,
} from './use-shared-dd';
